import { getMessageFactoryV2 } from "../getCaxaWebSocketV2.js";
const createOrderFileV2 = getMessageFactoryV2({
  code: "CREATE_ORDER_FILE"
});
export { createOrderFileV2 };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/caxa/directive/createOrderFileV2.js